import { useContext } from 'react';
import { LanguageContext } from './LanguageContext';

export const useI18n = () => {
  const ctx = useContext(LanguageContext);
  return ctx;
};
